export default __webpack_public_path__ + "static/media/section1_bg.741b00cb.png";